import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Router from './router';
import { ErrorBoundary } from './router/ErrorBoundary';
import { ToastContainer } from './components/UpToast';
import './index.css';

const queryClient = new QueryClient();

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <div className="bg-up-black-5 flex flex-col max-w-[768px] mx-auto h-full">
            <div className="flex-1 page-scroll">
              <Router />
            </div>
          </div>
          <ToastContainer />
        </QueryClientProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
